// extracted by mini-css-extract-plugin
module.exports = {"container":"_1N5s0bwtDJkMPnNuoQD4vc"};